<div>
    <div class="actions">
        <button (click)="addVehicle()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Add Vehicle'">
            <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Vehicle
        </button>
        <button (click)="openBulkUploadDialog()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Bulk Upload'">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload
        </button>
        <button
                type="button"
                class="btn-icon-action"
                (click)="downloadTemplate()"
                [disabled]="role === 'Member'"
                title="Download Template">
            <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
        </button>
    </div>

    <app-bulk-import-result
            *ngIf="bulkUpload.result"
            [totalImported]="bulkUpload.result.totalImported"
            [totalFailed]="bulkUpload.result.totalFailed"
            [errors]="bulkUpload.result.errors"
            [failedRowsCsvBase64]="bulkUpload.result.failedRowsCsvBase64"
            [failedRowsFilename]="bulkUpload.result.failedRowsFilename">
    </app-bulk-import-result>

    <div class="container-table">
        <div class="top-header">
            <h3>Vehicle Monitoring</h3>
            <p>Vehicle Monitoring Records As On {{ todayDate | reportingDate:'date' }}</p>
        </div>
        <div>
            <app-shared-table-toolbar>
                <div toolbarSearch class="search-bar wide-search-bar">
                    <app-generic-search
                            [apiUrl]="'vehicle-alert-rules/search_suggestion'"
                            [resultsApiUrl]="'vehicle-monitoring/'"
                            [method]="'GET'"
                            [searchParamName]="'q'"
                            [pageSize]="10"
                            [minChars]="2"
                            [extraBody]="searchExtraBody"
                            (resultsFetched)="onResults($event)">
                    </app-generic-search>
                </div>
                <div toolbarFilters class="filters table-filters">
                    <div class="filter">
                        <label>Monitoring Type</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedAlertTypes"
                                (selectionApplied)="applyAlertTypeFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                    <div class="filter">
                        <label>Severity</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedSeverities"
                                [options]="severityFilterOptions"
                                [orderedValues]="severityFilterOrder"
                                allSelectedLabel="All Severities"
                                (selectionApplied)="applySeverityFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                </div>
                <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                </button>
            </app-shared-table-toolbar>
            <app-shared-bulk-selection-banner
                    *ngIf="canBulkDelete"
                    [visible]="hasBulkSelection"
                    [selectedCount]="bulkSelectedCount"
                    [matchingCount]="totalRecords"
                    [mode]="bulkSelection.mode"
                    [showSelectAllMatching]="true"
                    itemLabel="vehicles"
                    (selectAllMatching)="onSelectAllMatching()"
                    (clearSelection)="onClearBulkSelection()">
                <button bulkSelectionActions
                        type="button"
                        class="btn-action"
                        (click)="openBulkDeletePreview()"
                        [disabled]="!hasBulkSelection || bulkDeleting"
                        title="Bulk Delete selected monitored vehicles">
                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                    Bulk Delete
                </button>
            </app-shared-bulk-selection-banner>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th *ngIf="canBulkDelete">
                            <input type="checkbox"
                                   class="vehicle-select-checkbox"
                                   [checked]="allVisibleVehiclesSelected"
                                   (change)="toggleSelectAllVehicles($any($event.target).checked)">
                        </th>
                        <th>S.No</th>
                        <th class="sortable-header" (click)="sortData('vehicle_number')">
                            Vehicle Number
                            <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                        </th>
                        <th>Monitoring Types</th>
                        <th class="sortable-header" (click)="sortData('highest_severity')">
                            Severity
                            <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'highest_severity' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'highest_severity' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                        </th>
                        <th class="sortable-header" (click)="sortData('remarks')">
                            Remarks
                            <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'remarks' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'remarks' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                        </th>
                        <th class="sortable-header" (click)="sortData('created_by')">
                            Created By
                            <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_by' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_by' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                        </th>
                        <th class="sortable-header" (click)="sortData('created_on')">
                            Created On
                            <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_on' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_on' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                        </th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="vehicles.length === 0">
                        <td [attr.colspan]="canBulkDelete ? 9 : 8" class="empty-state">No monitored vehicles found.</td>
                    </tr>
                    <tr *ngFor="let record of vehicles; let i = index">
                        <td *ngIf="canBulkDelete">
                            <input type="checkbox"
                                   class="vehicle-select-checkbox"
                                   [checked]="isVehicleSelected(record.vehicle_number)"
                                   (change)="toggleVehicleSelection(record.vehicle_number, $any($event.target).checked)">
                        </td>
                        <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                        <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                        <td>
                            <div class="monitoring-type-badges">
                                <app-monitoring-type-badge
                                        *ngFor="let rule of record.monitoring_rules"
                                        [monitoringType]="rule.type"
                                        [displayLabel]="rule.type_display">
                                </app-monitoring-type-badge>
                            </div>
                        </td>
                        <td>
                            <app-severity-badge
                                    [severity]="record.highest_severity"
                                    [displayLabel]="record.highest_severity_display">
                            </app-severity-badge>
                        </td>
                        <td>
                            <div class="content-tooltip-container">
                                <div class="text-clip"
                                     (mouseenter)="hoverRowKey=record.vehicle_number"
                                     (mouseleave)="hoverRowKey=null">
                                    {{ record.remarks || '-' }}
                                </div>
                                <div class="content-tooltip"
                                     *ngIf="hoverRowKey === record.vehicle_number && record.remarks && record.remarks !== 'Multiple' && record.remarks.length > 30">
                                    {{ record.remarks }}
                                </div>
                            </div>
                        </td>
                        <td>{{ record.created_by }}</td>
                        <td>{{ record.created_on | reportingDate }}</td>
                        <td class="table-actions-cell">
                            <span class="table-actions">
                                <button type="button" class="action-button bt-edit" (click)="editVehicle(record.id)"
                                        [disabled]="role === 'Member'"
                                        [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Edit'">
                                    <span>
                                        <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                                    </span>
                                </button>
                                <button type="button" class="action-button bt-delete" (click)="openDeleteDialog(record)"
                                        [disabled]="role === 'Member'"
                                        [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Remove'">
                                    <span>
                                        <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                                    </span>
                                </button>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="footer">
                    <div class="footer-summary">
                        <div class="total-records">Grouped Vehicles: {{ totalRecords }}</div>
                        <div class="total-records">Total Monitoring Rules: {{ totalMonitoringRules }}</div>
                        <p class="table-helper-text">Each vehicle may contain multiple monitoring rules.</p>
                    </div>
                    <app-vte-pagination
                            [currentPage]="currentPage"
                            [pageSize]="recordsPerPage"
                            [totalRecords]="totalRecords"
                            [showJumpToPage]="true"
                            (pageChange)="onPageChange($event)"
                            (pageSizeChange)="onPageSizeChange($event)">
                    </app-vte-pagination>
                </div>
            </div>
        </div>
    </div>
</div>

<app-bulk-upload-shell
        mode="modal"
        [open]="bulkUpload.dialogOpen"
        [title]="bulkUploadShell.title || 'Bulk Upload'"
        [intro]="bulkUploadShell.intro || ''"
        [uploading]="bulkUpload.uploading"
        [disabled]="role === 'Member'"
        [selectedFile]="bulkUpload.selectedFile"
        [showDownloadTemplate]="!!bulkUploadShell.showDownloadTemplate"
        [supportedFields]="bulkUploadShell.supportedFields || []"
        [supportedTip]="bulkUploadShell.supportedTip"
        (fileSelected)="onBulkFileSelected($event)"
        (submitUpload)="submitBulkUpload($event)"
        (cancel)="closeBulkUploadDialog()">
</app-bulk-upload-shell>

<div *ngIf="showDeleteDialog && selectedVehicle" class="confirmation-modal delete-monitoring-modal">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon"></i>
            <h3>Delete Vehicle Monitoring</h3>
        </div>
        <div class="modal-body delete-monitoring-body">
            <p><strong>Vehicle:</strong> {{ selectedVehicle.vehicle_number }}</p>
            <p class="delete-monitoring-label">Monitoring Types</p>
            <label *ngFor="let rule of selectedVehicle.monitoring_rules" class="delete-monitoring-option">
                <input
                        type="checkbox"
                        [checked]="isRuleSelected(rule.id)"
                        (change)="toggleRuleSelection(rule.id, $any($event.target).checked)">
                <app-monitoring-type-badge
                        [monitoringType]="rule.type"
                        [displayLabel]="rule.type_display">
                </app-monitoring-type-badge>
            </label>
        </div>
        <div class="button-row">
            <button type="button" class="btn-cancel" (click)="closeDeleteDialog()" [disabled]="deleting">Cancel</button>
            <button type="button" class="btn-action modal-red" (click)="deleteSelectedRules()"
                    [disabled]="selectedRuleIds.size === 0 || deleting">
                {{ deleting ? 'Deleting...' : 'Delete Selected' }}
            </button>
        </div>
    </div>
</div>

<app-bulk-delete-preview-shell
        [open]="showBulkDeleteDialog && !!bulkDeletePreview"
        title="Confirm Monitoring Rule Deletion"
        selectedLabel="Selected monitored vehicles"
        [selectedCount]="bulkDeletePreview?.selected_records ?? bulkSelectedCount"
        willDeleteTitle="Records That Will Be Deleted"
        [willDelete]="bulkDeleteWillDelete"
        retainedTitle="Records That Will Be Preserved"
        [relatedRetained]="bulkDeleteRetained"
        [assurances]="bulkDeleteAssurances"
        footerMessage="Only monitoring configuration is removed."
        [confirming]="bulkDeleting"
        confirmLabel="Yes, Delete Monitoring Rules"
        (confirm)="confirmBulkDelete()"
        (cancel)="closeBulkDeleteDialog()">
</app-bulk-delete-preview-shell>
